import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Loading from '../hub/screens/Loading';

/**
 * Component used to lazy load route components rendered by react-router.
 *
 * @see https://reacttraining.com/react-router/web/guides/code-splitting
 */
class Bundle extends PureComponent {
  constructor(props) {
    super(props);
    this.willUnmount = false;
    this.state = { mod: null };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.load !== this.props.load) {
      this.load();
    }
  }

  componentWillUnmount() {
    this.willUnmount = true;
  }

  load() {
    if (this.willUnmount) return;
    this.setState({ mod: null });
    this.props.load((mod) => {
      if (this.willUnmount) return;
      this.setState({ mod: mod.default ? mod.default : mod });
    });
  }

  render() {
    // on initial render, before the loading of the new state.mod is complete, show our loading screen
    if (this.state.mod) {
      return this.props.children(this.state.mod);
    }
    // in some cases if we load just small components we may not want loader appear
    return this.props.showLoader ? <Loading /> : null;
  }
}

Bundle.propTypes = {
  children: PropTypes.func,
  load: PropTypes.func,
  showLoader: PropTypes.bool,
};

Bundle.defaultProps = {
  children: () => { },
  load: () => { },
  showLoader: true,
};

export default Bundle;
